import { FORGET_PASSWORD, } from '../Action/type';

const initialState = {
    isResistered: false,
    user: {}
}

export default function(state = initialState, action) {
    switch (action.type) {
        case FORGET_PASSWORD:
            return {
                ...state,
                user: action.payload
            };
            // case SELLER_REGISTRATION_FORM:
            //     return {
            //         ...state,
            //         user: action.payload
            //     };

        default:
            return state;
    }
}